<script>
    import { fly } from "svelte/transition";
    import { Rate, Toast, notify } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Rate on:change={(e) => notify.show(`评分为:${e.detail}分`)} />
    </div>
    <h4 class="example-title">不可清除</h4>
    <div class="example-body">
        <Rate
            allowClear={false}
            on:change={(e) => notify.show(`评分为:${e.detail}分`)}
        />
    </div>
    <h4 class="example-title">只读</h4>
    <div class="example-body">
        <Rate defaultValue={2} readOnly={true} />
    </div>
    <h4 class="example-title">自定义颜色</h4>
    <div class="example-body">
        <Rate
            inActiveColor={"green"}
            on:change={(e) => notify.show(`评分为:${e.detail}分`)}
            defaultValue={2}
            activeColor={"red"}
        />
    </div>
    <h4 class="example-title">自定义count</h4>
    <div class="example-body">
        <Rate
            defaultValue={2}
            on:change={(e) => notify.show(`评分为:${e.detail}分`)}
            count={8}
        />
    </div>
    <h4 class="example-title">自定义size</h4>
    <div class="example-body">
        <Rate defaultValue={2} --icon-size="36px" />
    </div>
</div>

<Toast />

<style lang="less">
    @import "./example.less";
</style>
